import React from 'react';
import ReactDOM from 'react-dom';

/**
 *   Import Fontawesome Icons
 *   For adding new icons -> import { faName } from '@fortawesome/pro-SIZE-svg-icons'
 *   Add to the library.add();
 *   ---
 *   In the file where you want the icon -> import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
 *   Then in render -> <FontAwesomeIcon icon={['abbreviationSize', 'faName']}/>
 *   ---
 *   When adding icons from same SIZE, please import in same import line
 *   ---
 *   If the same icon needs to be added from multiple SIZES -> import { faName as abbreviationSizeFaName }
 *   ---
 *   Abbreviations:
 *   far = fontawesome pro regular
 *   fas = fontawesome pro solid
 *   fab = fontawesome pro brands
 *   fal = fontawesome pro light
 *   ---
 */
import { library } from '@fortawesome/fontawesome-svg-core';
import {} from '@fortawesome/pro-regular-svg-icons';
import { faCircleNotch as falFaCircleNotch } from '@fortawesome/pro-light-svg-icons';
import {} from '@fortawesome/pro-solid-svg-icons';

import './styles/App.scss';
import App from 'components/App';

library.add(falFaCircleNotch);

ReactDOM.render(<App />, document.getElementById('root'));
